module.exports = __webpack_public_path__ + "static/img/yagi_01.94993d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yagi_01.jpg
// module id = nsHm
// module chunks = 0